import type { ParseKeys } from 'i18next';
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  getEvaluationOption,
  getEvaluationText,
} from '@/components/PreschoolEvaluationModal/evaluation';
import {
  PreschoolCriterionType,
  PreschoolEvaluationOption,
} from '@/types/components';
import type { PreschoolCriterion } from '@/types/preschool';
import { linkifyText } from '@/utils/html';

const evaluationLabelKeys: Record<PreschoolEvaluationOption, ParseKeys> = {
  [PreschoolEvaluationOption.Yes]: 'preschoolEvaluation.yes',
  [PreschoolEvaluationOption.No]: 'preschoolEvaluation.no',
  [PreschoolEvaluationOption.Partially]: 'preschoolEvaluation.partially',
};

interface Props {
  criterion: PreschoolCriterion;
  disciplineOrderNumber: number;
}

export const CriterionRow: React.FC<Props> = ({
  criterion,
  disciplineOrderNumber,
}) => {
  const { t } = useTranslation();

  const { orderNumber, criterionName, type } = criterion;
  const option = getEvaluationOption(criterion);
  const showEvaluationText =
    type === PreschoolCriterionType.Bool ||
    type === PreschoolCriterionType.Text;

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-start justify-between gap-3">
        <p className="text-body-14 text-muted-foreground">
          {`${disciplineOrderNumber}.${orderNumber}. ${criterionName}`}
        </p>
        {option && (
          <p className="text-subhead-14 shrink-0 text-foreground">
            {t(evaluationLabelKeys[option])}
          </p>
        )}
      </div>
      {showEvaluationText && (
        <p
          className="rich-text text-body-14 min-h-11 w-full rounded-[10px] border border-transparent bg-background p-3 whitespace-pre-line text-foreground contrast:border-border"
          dangerouslySetInnerHTML={{
            __html: linkifyText(getEvaluationText(criterion)),
          }}
        />
      )}
    </div>
  );
};
